import React from "react";
import CookiesPolicy from "../components/CookiesPolicy";

function CookiesPolicyPage() {
  return <CookiesPolicy />;
}

export default React.memo(CookiesPolicyPage);
